import React, { useState, useEffect, useRef } from "react";
import styles from "./SearchBar.module.css";
import { allProducts } from "./../../API/ProductsAPI";
import { NavLink } from "react-router-dom";

const SearchBar = (props) => {
    const [query, setQuery] = useState("");
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [showSortOptions, setShowSortOptions] = useState(false);
    const sortDropdownRef = useRef(null); // Referință la dropdown

    // Detectează schimbarea dimensiunii ferestrei
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Închide meniul la clic în afara acestuia sau scroll
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                sortDropdownRef.current &&
                !sortDropdownRef.current.contains(event.target)
            ) {
                setShowSortOptions(false);
            }
        };

        const handleScroll = () => {
            setShowSortOptions(false);
        };

        document.addEventListener("mousedown", handleClickOutside);
        window.addEventListener("scroll", handleScroll);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setQuery(value);
        const filtered = allProducts
            .filter((product) => product.name.toLowerCase().includes(value))
            .map((product) => ({
                id: product.id,
                image: product.image,
                name: product.name,
                price: product.price,
            }));
        setFilteredProducts(filtered);
    };

    const handleSort = (value) => {
        if (value === "priceAsc") props.sortBy("PRICE", "ASCENDING");
        if (value === "priceDesc") props.sortBy("PRICE", "DESCENDING");
        if (value === "nameAsc") props.sortBy("NAME", "ASCENDING");
        if (value === "nameDesc") props.sortBy("NAME", "DESCENDING");
        setShowSortOptions(false); // Ascunde opțiunile după selecție
    };

    return (
        <div ref={props.productsRef} className={styles.container}>
            <div className={styles.searchBar}>
                {/* Search Input */}
                <div className={styles.searchInput}>
                    <input
                        type="text"
                        placeholder="Caută un produs..."
                        value={query}
                        className={styles.input}
                        onChange={handleSearch}
                    />
                    <button type="button" className={styles.searchButton}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            width="14"
                            height="14"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="4"
                                d="M21 21l-4.35-4.35m1.4-4.65a7 7 0 11-14 0 7 7 0 0114 0z"
                            />
                        </svg>
                    </button>
                    {query && (
                        <div className={styles.resultsContainer}>
                            {filteredProducts.map((product, index) => (
                                <NavLink to={`/product/${product.id}`} key={index} className={styles.resultItem}>
                                    <img src={product.image} alt={product.name} className={styles.resultImage} />
                                    <div>
                                        <h4 className={styles.resultName}>{product.name}</h4>
                                        <p className={styles.resultPrice}>{product.price} RON</p>
                                    </div>
                                </NavLink>
                            ))}
                            {filteredProducts.length === 0 && (
                                <p className={styles.noResults}>Nu s-au găsit rezultate.</p>
                            )}
                        </div>
                    )}
                </div>

                {/* Dropdown */}
                <div
                    className={styles.sortDropdown}
                    ref={sortDropdownRef} // Referință la dropdown
                >
                    {isMobile ? (
                        <button
                            className={styles.sortIcon}
                            onClick={() => setShowSortOptions(!showSortOptions)}
                        >
                            <i className="fa-solid fa-arrow-down-short-wide fa-lg"></i>
                        </button>
                    ) : (
                        <select
                            defaultValue=""
                            onChange={(e) => handleSort(e.target.value)}
                        >
                            <option value="" disabled hidden>
                                Sortați după
                            </option>
                            <option value="priceAsc">Preț Crescător</option>
                            <option value="priceDesc">Preț Descrescător</option>
                            <option value="nameAsc">Nume: A-Z</option>
                            <option value="nameDesc">Nume: Z-A</option>
                        </select>
                    )}
                    {showSortOptions && isMobile && (
                        <div className={styles.sortOptions}>
                            <button onClick={() => handleSort("priceAsc")}>Preț Crescător</button>
                            <button onClick={() => handleSort("priceDesc")}>Preț Descrescător</button>
                            <button onClick={() => handleSort("nameAsc")}>Nume: A-Z</button>
                            <button onClick={() => handleSort("nameDesc")}>Nume: Z-A</button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SearchBar;
